<ion-content class="ion-padding">
  <ion-searchbar debounce="10" style="--border-radius: 50px;position: sticky;top: 0;z-index: 100;"
    [placeholder]="manager.Trad.Parse('STR_PLACEHOLDER')" [(ngModel)]="filterContact" class="custom"></ion-searchbar>

  <div class="emptyList" *ngIf="!Contacts.length">{{manager.Trad.Parse("STR_EMPTY")}}</div>
  <ion-list *ngIf="Contacts.length" style="height: 100%;">
    <ion-item (click)="onSelect(contact)" *ngFor="let contact of Contacts"
      style="--border-color: var(--ion-color-secondary); --padding-start: 0px;  --inner-padding-end: 0px;">
      <ion-label>
        <h2 style="color: var(--ion-color-secondary)">{{contact.DisplayName}}</h2>
        <p>{{contact.Email}}</p>
      </ion-label>
      <ion-icon style=" color: var(--ion-color-primary)" slot="end" *ngIf="contact.IsDefault" name="star"></ion-icon>
    </ion-item>
  </ion-list>
</ion-content>